import { Log } from 'ng2-logger';
import React, { useEffect } from 'react';
import { connect } from 'react-redux';
import Spinner from '../../components/templates/spinner';
import Translator from '../../services/translate-factory';
import * as Actions from '../../store/actions/general';
import * as Constants from '../../store/constants/all';
import { routes } from '../../store/constants/routes';
import type * as Types from '../../store/types';
import * as GT from '../../tools/general-tools';
import styles from './constr-login-callback.module.css';

declare const appSettings: Types.IAppSettings;

const L = Log.create('ConstrLoginCallback');
const T = Translator.create();

type ConstrLoginProps = {
  dispatch?: any;
  user?: Types.IAuthUser;
  auth?: any;
};

export const IConstrLoginCallback = ({ dispatch, user, auth }: ConstrLoginProps) => {
  useEffect(() => {
    handleCallback();
  }, []);

  const handleCallback = () => {
    try {
      L.data('Processing IDP callback...');

      // unauthorized access to callback page
      if (!appSettings.CONSTRUCTOR_IDP) {
        L.error('Constructor IDP is not enabled in app settings');
        dispatch(
          Actions.Notification(
            'Authentication method not configured',
            'gen_login_failed',
            'danger',
          ),
        );
        dispatch(Actions.Navigation(GT.Route(routes.LOGIN)));
        return;
      }

      // IDP callback validation to the saga
      dispatch(
        Actions.ApiRequest(Constants.login.LOGIN_IDP_CALLBACK, undefined, 'login-callback-spin'),
      );
    } catch (err) {
      L.error('Error in callback handling:', err);
      dispatch(
        Actions.Notification(
          'Failed to process authentication callback',
          'gen_login_failed',
          'danger',
        ),
      );
      dispatch(Actions.Navigation(GT.Route(routes.LOGIN)));
    }
  };

  return (
    <div
      className={`${styles.loadingOverlay} d-flex flex-column justify-content-center align-items-center bg-light`}
    >
      <div className={styles.loadingContent}>
        <div className={styles.loadingText}>
          <h4 className="text-muted mb-2">{T.t('login_processing_auth')}</h4>
          <p className="text-secondary">{T.t('login_processing_auth_desc')}</p>
        </div>
      </div>
    </div>
  );
};

const mapStateToProps = (store: any) => ({
  user: store.state.user,
  auth: store.state.auth,
});

const dispatchProps = (dispatch: any) => ({ dispatch });

export default connect(mapStateToProps, dispatchProps)(IConstrLoginCallback);
